module.exports = __webpack_public_path__ + "img/59.dfb00cb9.png";